

import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";
import { ReportService } from "@/services/report-service";
import { StaticReport } from "@/models/static-report";
import { JobService } from "@/services/job-service";
import AppAccountingIntraConsignmentModal from "@/components/bookkeeping/AccountinginitIntraConsignmentModal.vue";
import AppUblOverview from "@/components/bookkeeping/UblOverview.vue";
import AppCreateVatDeclarationModal from "@/components/bookkeeping/AccountingVatDeclarationModal.vue";
import { checkHasModule } from "@/router";
import { MODULE } from "@/config/modules";
import AppVatListingModal from "@/components/bookkeeping/AccountingVatListingModal.vue";
import AppDashboardReportItem from "@/components/bookkeeping/DashboardReportItem.vue";
import { ReportType } from "@/utils/report-engine-settings/report-engine-settings";
import AppAccountingIntrastatModal from "@/components/bookkeeping/AccountingIntrastatModal.vue";
import { CustomButton } from "@/utils/buttons/custom-button";
import { UserConfigService } from "@/services/user-config-service";
import { AuthService } from "@/services";
import AppCustomButtonModal from "@/components/browse/CustomButtonModal.vue";
import AppExportToWinbooksModal from "@/components/accountant/ExportToWinbooksModal.vue";
import { WinbooksService } from "@/services/winbooks-service";
import AppUpdateBookYearModal from "@/components/bookkeeping/UpdateBookYearModal.vue";

export default Vue.extend({
	data() {
		return {
			JobService,
			intraConsignmentModal: false,
			vatDeclarationModal: false,
			vatListingModal: false,
			intrastatModal: false,
			showCustomButtonModal: false,
			activeCustomButton: null as CustomButton | null,
			winbooksActive: false,
			winbooksModal: false,
			updateBookYearModal: false
		};
	},
	computed: {
		hasFixedAssetsModule():boolean {
			return AuthService.isDevModeEnabled && AuthService.hasModule(MODULE.AFSCHRIJVINGSTABELLEN);
		},
		customButtons(): CustomButton[] {
			return UserConfigService.getCustomReportButtonsForKey("Bookkeeping").filter(btn => {
				if (btn.AdminOnly && !AuthService.isDevModeEnabled) {
					return false;
				}
				return true;
			});
		}
	},
	methods: {
		async purchaseJournalEntries(reportType:ReportType){

			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}

			let reports = await ReportService.getReportEngineSettingsByName("bookkeeping");
			let settings = reports.staticReports.find(r=>r.Settings.DataSource == "standard-script/purchase-journal-entries");
			if(settings){
				settings.library = "bookkeeping";
				let r = new StaticReport(settings,0,4);
				ReportService.openCreateReportModal(r, reportType);
			}
		},
		async saleJournalEntries(reportType:ReportType){

			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}

			let reports = await ReportService.getReportEngineSettingsByName("bookkeeping");
			let settings = reports.staticReports.find(r=>r.Settings.DataSource == "standard-script/sale-journal-entries");
			if(settings){
				settings.library = "bookkeeping";
				let r = new StaticReport(settings,0,5);
				ReportService.openCreateReportModal(r, reportType);
			}
		},
		async diverseJournalEntries(reportType:ReportType){

			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}

			let reports = await ReportService.getReportEngineSettingsByName("bookkeeping");
			let settings = reports.staticReports.find(r=>r.Settings.DataSource == "standard-script/diverse-journal-entries");
			if(settings){
				settings.library = "bookkeeping";
				let r = new StaticReport(settings,0,6);
				ReportService.openCreateReportModal(r, reportType);
			}
		},
		async bankJournalEntries(reportType:ReportType){

			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}

			let reports = await ReportService.getReportEngineSettingsByName("bookkeeping");
			let settings = reports.staticReports.find(r=>r.Settings.DataSource == "standard-script/bank-journal-entries");
			if(settings){
				settings.library = "bookkeeping";
				let r = new StaticReport(settings,0,7);
				ReportService.openCreateReportModal(r, reportType);
			}
		},
		async bookkeepingCheckReport(reportType:ReportType){

			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}

			let reports = await ReportService.getReportEngineSettingsByName("bookkeeping");
			let settings = reports.staticReports.find(r=>r.Settings.DataSource == "standard-script/bookkeeping-check");
			if(settings){
				settings.library = "bookkeeping";
				let r = new StaticReport(settings,0,3);
				ReportService.openCreateReportModal(r, reportType);
			}
		},
		async balanceReport(reportType:ReportType){
			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}

			let reports = await ReportService.getReportEngineSettingsByName("bookkeeping");
			let settings = reports.staticReports.find(r=>r.Settings.DataSource == "standard-script/balance");
			if(settings){
				settings.library = "bookkeeping";
				let r = new StaticReport(settings,0,0);
				ReportService.openCreateReportModal(r, reportType);
			}
		},
		async incomeStatementReport(reportType:ReportType){
			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}

			let reports = await ReportService.getReportEngineSettingsByName("bookkeeping");
			let settings = reports.staticReports.find(r=>r.Settings.DataSource == "standard-script/income-statement");
			if(settings){
				settings.library = "bookkeeping";
				let r = new StaticReport(settings,0,1);
				ReportService.openCreateReportModal(r, reportType);
			}
		},
		async incomeStatementDetailReport(reportType:ReportType){
			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}

			let reports = await ReportService.getReportEngineSettingsByName("bookkeeping");
			let settings = reports.staticReports.find(r=>r.Settings.DataSource == "standard-script/income-statement-detail");
			if(settings){
				settings.library = "bookkeeping";
				let r = new StaticReport(settings,0,2);
				ReportService.openCreateReportModal(r, reportType);
			}
		},
		openIntraConsignment(){
			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}
			this.intraConsignmentModal = true;
		},
		openCreateVatDeclarationModal(){
			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}
			this.vatDeclarationModal = true;
		},
		openLedgerAccountModal(){
			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}
			this.$router.push("/bookkeeping/ledger-accounts");
		},
		openCreateVatListingModal(){
			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}
			this.vatListingModal = true;
		},
		openCreateIntrastatModal(){
			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}
			this.intrastatModal = true;
		},
		openDetailBrowse(){
			if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
				throw new Error("MISSING MODULE");
			}
			this.$router.push("/bookkeeping/bookkeeping");
		},
		openCustomButton(btn: CustomButton){
			this.activeCustomButton = btn;
			this.showCustomButtonModal = true;
		}
	},
	async mounted() {
		ToolbarService.title = this.$ct("title");
		this.winbooksActive = await WinbooksService.isActiveForDossier();
	},
	async created(){

	},
	components: {
		AppAccountingIntraConsignmentModal,
		AppCreateVatDeclarationModal,
		AppUblOverview,
		AppVatListingModal,
		AppDashboardReportItem,
		AppAccountingIntrastatModal,
		AppCustomButtonModal,
		AppExportToWinbooksModal,
		AppUpdateBookYearModal
	},
	i18nEx: {
		componentPrefix: "components.bookkeeping"
	}
});
